import { useEffect, useRef } from "react";
import { toast } from "sonner";
import { api } from "../lib/api";

/**
 * Polls `/notifications/due-toasts` once on mount and then every 60s.
 * Surfaces `review_reminder_auto` entries as brief 5s toasts. The backend
 * marks each row as `toasted_at` so the same reminder never re-toasts.
 *
 * Mounted once in App.js — silent for guests / failed auth.
 */
export function ReviewToastPoller() {
  const seen = useRef(new Set());

  useEffect(() => {
    let cancelled = false;
    const tick = async () => {
      try {
        const { data } = await api.get("/notifications/due-toasts");
        if (cancelled) return;
        (data.items || []).forEach((n) => {
          if (seen.current.has(n.id)) return;
          seen.current.add(n.id);
          toast(n.message || "How was your visit? Leave a quick review.", {
            duration: 5000,
          });
        });
      } catch {
        // Silent — guests + offline both expected.
      }
    };
    tick();
    const i = setInterval(tick, 60000);
    return () => { cancelled = true; clearInterval(i); };
  }, []);

  return null;
}

export default ReviewToastPoller;
